'use strict';

var React = require('react');

var SvgRefreshMajor = function SvgRefreshMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.707 3.293a1 1 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.631-.324 1 1 0 0 1 .217-1.09l1.293-1.293h-9.586c-2.206 0-4 1.794-4 4a1 1 0 0 1-2 0c0-3.309 2.691-6 6-6h9.586l-1.293-1.293a1 1 0 1 1 1.414-1.414l3 3zm-2.707 6.707a1 1 0 0 1 1 1c0 3.31-2.69 6-6 6h-8.586l1.293 1.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 1 1 1.414 1.414l-1.293 1.293h8.586c2.206 0 4-1.794 4-4a1 1 0 0 1 1-1z"
  }));
};

exports.SvgRefreshMajor = SvgRefreshMajor;
